import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  getSubjects: () => client.get("/subjects").then((r) => r.data),
  createSubject: (data) => client.post("/subjects", data).then((r) => r.data),
  deleteSubject: (id) => client.delete(`/subjects/${id}`).then((r) => r.data),

  getMaterials: (subjectId, q) =>
    client.get("/materials", { params: { ...(subjectId ? { subject_id: subjectId } : {}), ...(q ? { q } : {}) } }).then((r) => r.data),
  getMaterial: (id) => client.get(`/materials/${id}`).then((r) => r.data),
  createMaterial: (data) => client.post("/materials", data).then((r) => r.data),
  uploadMaterial: (formData) =>
    client.post("/materials/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  uploadMaterialMulti: (formData) =>
    client.post("/materials/upload-multi", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  deleteMaterial: (id) => client.delete(`/materials/${id}`).then((r) => r.data),

  summary: (id, format) => client.post(`/materials/${id}/summary`, { format }).then((r) => r.data),
  quiz: (id, count = 6) => client.post(`/materials/${id}/quiz`, { count }).then((r) => r.data),
  flashcards: (id, count = 8) => client.post(`/materials/${id}/flashcards`, { count }).then((r) => r.data),
  openQuestions: (id, count = 6) => client.post(`/materials/${id}/open-questions`, { count }).then((r) => r.data),
  evaluate: (id, question, answer) => client.post(`/materials/${id}/evaluate`, { question, answer }).then((r) => r.data),

  saveAttempt: (id, data) => client.post(`/materials/${id}/attempts`, data).then((r) => r.data),
  getAttempts: (id) => client.get(`/materials/${id}/attempts`).then((r) => r.data),
  mixedQuiz: (subjectId, count = 8) => client.post(`/subjects/${subjectId}/mixed-quiz`, { count }).then((r) => r.data),
  examQuiz: (count = 10, subject_ids = null) => client.post("/exam-quiz", { count, subject_ids }).then((r) => r.data),
  saveExamAttempt: (data) => client.post("/exam-attempts", data).then((r) => r.data),
  getExamAttempts: () => client.get("/exam-attempts").then((r) => r.data),
  conceptMap: (id) => client.post(`/materials/${id}/concept-map`).then((r) => r.data),

  progress: () => client.get("/progress").then((r) => r.data),
  weeklySummary: () => client.get("/weekly-summary").then((r) => r.data),

  dailyChallenge: () => client.get("/daily-challenge").then((r) => r.data),
  dailyStatus: () => client.get("/daily-challenge/status").then((r) => r.data),
  completeDaily: (data) => client.post("/daily-challenge/complete", data).then((r) => r.data),
  getGoals: () => client.get("/goals").then((r) => r.data),
  setGoal: (id, target_pct) => client.put(`/subjects/${id}/goal`, { target_pct }).then((r) => r.data),

  stats: () => client.get("/stats").then((r) => r.data),
};
